/* tslint:disable */

/**
 */
export class CardMonthGroupBusStationForm {
    from_date?: string;
    to_date?: string;
    user_id?: number;
}
